// HomePage.js
import React from 'react';
import Hero from '../components/Hero';
import BestCaregiversSection from '../components/BestCaregiversSection';
import QuickLinksSection from '../components/QuickLinksSection';
import ThreeStepsSection from '../components/ThreeStepsSection';
import HelpingFamiliesSection from '../components/HelpingFamiliesSection';
import ProudlyCaringSection from '../components/ProudlyCaringSection';


const HomePage = () => {
  return (
    <div>
      <Hero />
      <BestCaregiversSection />
      <QuickLinksSection />
      <ThreeStepsSection />
      <HelpingFamiliesSection />
      <ProudlyCaringSection />
    </div>
  );
};

export default HomePage;
